import ApiClient from './ApiClient';

class TestPersonasAPI extends ApiClient {
  constructor() {
    super('test_personas', { accountScoped: true });
  }
}

export default new TestPersonasAPI();
